import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { debounce: { type: Number, default: 300 } }

  submit() {
    this.element.requestSubmit()
  }

  submitDebounced() {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => this.submit(), this.debounceValue)
  }
}
